import httpClient from '@/lib/httpClient'
import { handleFormError } from '@/utils/helpers'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

export default function useSetDefaultTeam({
  setError = null,
  clientServerFieldMapping = null,
} = {}) {
  const queryClient = useQueryClient()

  const action = async ({ teamId }: { teamId: number }) => {
    const response = await httpClient.post(
      `/team/team/${teamId}/set-default`,
      {
        team_id: teamId,
      },
    )
    return response
  }

  const mutation = useMutation({
    mutationFn: action,
    onSuccess: (res, variables) => {
      toast.success('Default space updated')
      queryClient.invalidateQueries({ queryKey: ['teams'] })
    },
    onError: (error, variables) =>
      handleFormError({
        error,
        variables,
        setError,
        clientServerFieldMapping,
      }),
  })

  return {
    action: mutation.mutateAsync,
    status: mutation,
  }
}
